import { call, put, takeEvery } from "redux-saga/effects"
import { GET_ADMIN_LEAD_PRICES, UPDATE_ADMIN_LEAD_PRICE } from "./actionTypes"
import { getAdminLeadPricesSuccess, getAdminLeadPricesError, updateAdminLeadPriceSuccess, updateAdminLeadPriceError } from "./actions"
import { genericGetRequest, genericPutRequest } from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminLeadPrices() {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_lead_prices`;
    const request_payload = {
      body: {},
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericGetRequest, URL, request_payload.body, request_payload.headers)
    yield put(getAdminLeadPricesSuccess(response))
  } catch (error) {
    yield put(getAdminLeadPricesError(error))
  }
}

function* onUpdateAdminLeadPrices(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_lead_prices/${action.payload.id}`;
    const request_payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPutRequest, URL, request_payload)
    yield put(updateAdminLeadPriceSuccess(response))
  } catch (error) {
    yield put(updateAdminLeadPriceError(error))
  }
}


function* AdminLeadPricesSaga() {
  yield takeEvery(GET_ADMIN_LEAD_PRICES, onGetAdminLeadPrices);
  yield takeEvery(UPDATE_ADMIN_LEAD_PRICE, onUpdateAdminLeadPrices);
}

export default AdminLeadPricesSaga;

